import React, { useEffect, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
const ContactBlock = () => {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    message: Yup.string().required('Message is required'),
  });
  const initailValues = {
    name: '',
    email: '',
    message: '',
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await fetch('https://wukladiary.com/public/mailer/process_form.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });
      const result = await response.json();
      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Message Send Successfully",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
          position: 'top-end',
        });
        resetForm();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send message",
          text: result.error || "Please Try Again."
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to send message",
        text: "An unexpected error occurred. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <section id="contact" className="contact-area">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="section-title text-center wow fadeInUp delay-0-2s">
                <p>contact</p>
                <h2>Let’s Get Started</h2>
              </div>
            </div>
          </div>
          <div >
            <div className="row">
              <div className="col-lg-4 mb-3 mb-md-0">
                <div className="contact-content-part  wow fadeInUp delay-0-2s">
                  <div className="single-contact wow fadeInUp" data-wow-delay=".2s">
                    <div className="contact-icon"><i className="ri-map-pin-line"></i>
                    </div><h2>our office:</h2>
                    <p>Lahore, Pakistan</p>
                  </div>
                  <div className="single-contact wow fadeInUp" data-wow-delay=".4s">
                    <div className="contact-icon"><i className="ri-phone-line"></i>
                    </div>
                    <h2>contact number:</h2>
                    <p><a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=+923025788489&amp;text=Hi,%20I%20would%20like%20to%20get%20more%20information..">+923025788489</a></p>
                  </div>
                  <div className="single-contact wow fadeInUp" data-wow-delay=".6s">
                    <div className="contact-icon"><i className="ri-mail-line"></i>
                    </div><h2>Email us:</h2><p><a href="mailto:raozahid489@gmail.com">raozahid489@gmail.com</a></p>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 mb-3 mb-md-0">
                <div className="contact-form contact-form-area wow fadeInUp delay-0-4s">
                  <Formik
                    initialValues={initailValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ touched, errors }) => (

                      <Form id="contactForm" className="contactForm" >
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="name">Full Name</label>
                              <Field type="text" id="name" name="name" className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`} placeholder="Steve Milner" data-error="Please enter your Name" />
                              <label htmlFor="name" className="for-icon"><i className="far fa-user"></i></label>
                              <ErrorMessage name="name" component="div" className="text-danger error_text" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group"><label htmlFor="email">Email Address</label>
                              <Field type="email" id="email" name="email" className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`} placeholder="hello@websitename.com" data-error="Please enter your Email" />
                              <label htmlFor="email" className="for-icon"><i className="far fa-envelope"></i></label>
                              <ErrorMessage name="email" component="div" className="text-danger error_text" />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="message">Your Message</label>
                              <Field
                                as="textarea" name="message" id="message" className={`form-control ${touched.message && errors.message ? 'is-invalid' : ''}`} rows="4" placeholder="Write Your message" data-error="Please Write your Message" />
                              <ErrorMessage name="message" component="div" className="text-danger error_text" />

                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group mb-0">
                              <button type="submit" className="theme-btn">Send Me Message <i className="ri-mail-line"></i>
                              </button><div id="msgSubmit" className="hidden">
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}

                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default ContactBlock